<template>
  <div>
    <ValidationObserver slim ref="form">
      <form @submit.prevent="onSubmit">
        <div class="user-login-form ">
          <p class="form-item">
            <label for="login">Identifiant</label>
            <ValidationProvider slim name="login" rules="required|email" v-slot="{ classes, errors }">
              <input type="text" name="login" id="login" :class="classes" v-model="item.name"/>
              <span class="error-txt">{{ errors[0] }}</span>
            </ValidationProvider>
          </p>

          <p class="form-item">
            <label for="pwd">Mot de passe</label>
            <ValidationProvider slim name="pwd" rules="required" v-slot="{ classes, errors }">
              <input type="password" name="pwd" id="pwd" :class="classes" v-model="item.pass"/>
              <span class="error-txt">{{ errors[0] }}</span>
            </ValidationProvider>
          </p>
        </div>

        <div class="recaptcha" v-if="showCaptcha">
          <vue-recaptcha :sitekey="recaptcha_site_key"
                         ref="googleRecaptcha"
                         @verify="markRecaptchaAsVerified"
          ></vue-recaptcha>
          <p class="error-txt" v-if="recaptchaError">{{ recaptchaError }}</p>
        </div>

        <input type="submit" value="Se connecter"/>

      </form>
    </ValidationObserver>


    <p class="error-txt" v-if="error">{{ error }}</p>
  </div>
</template>
<script>

import VueRecaptcha from "vue-recaptcha";

export default {
  props: ['url_pro_homepage', 'recaptcha_site_key'],
  components: {VueRecaptcha},
  mounted() {
  },
  data() {
    return {
      loader: false,
      error: null,
      showCaptcha: false,
      recaptchaVerified: false,
      recaptchaError: null,
      item: {
        recaptcha_token: null,
      }
    }
  },
  methods: {
    markRecaptchaAsVerified(response) {
      this.recaptchaVerified = true;
      this.item.recaptcha_token = response;
    },
    onSubmit() {
      this.showCaptcha = false;
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }

        this.login();
      });
    },
    login() {
      if (this.loader)
        return;
      this.loader = true;
      this.error = null;
      axios({
        method: 'post',
        params: {
          _format: 'json'
        },
        url: window.Routes.login,
        data: this.item
      }).then((response) => {
        console.log(response);
        // Tracking user profil
        let profil;
        let user = response.data.current_user;
        if (user.roles && user.roles.indexOf('officine') !== -1)
          profil = 'Officine';
        if (user.roles && user.roles.indexOf('hopital') !== -1)
          profil = 'Hôpital';
        if (user.roles && user.roles.indexOf('medecin') !== -1)
          profil = 'Médecin';

        if (profil) {
          let datalayer = {
            event: 'login',
            'profil': profil,
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(datalayer);
        }
        let url_redirect = this.url_pro_homepage;
        if (response.data.url_reactivation !== undefined && response.data.url_reactivation != '') {
          url_redirect = response.data.url_reactivation;
        }
        window.location.href = url_redirect;
      }).catch((error) => {
        if (!this.recaptchaVerified) {
          this.recaptchaError = 'Merci de cocher le Captcha.';
          this.showCaptcha = true;
        } else {
          this.error = 'Il semblerait que vos identifiants soient incorrects. Veuillez réessayer.';
          this.recaptchaVerified = false;
        }

      }).finally(() => {
        this.loader = false;
      });
    }
  }
}
</script>
